document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(
    ".prescription-values-insert-manually-options"
  );
  const completeText = document.querySelector(".complete_all_fields");

  const hiddenInputs = {
    _sphere_left: document.getElementById("prop-sphere-left"),
    _sphere_right: document.getElementById("prop-sphere-right"),
    _cylinder_left: document.getElementById("prop-cylinder-left"),
    _cylinder_right: document.getElementById("prop-cylinder-right"),
    _axis_left: document.getElementById("prop-axis-left"),
    _axis_right: document.getElementById("prop-axis-right"),
    _add_left: document.getElementById("prop-add-left"),
    _add_right: document.getElementById("prop-add-right"),
    _pupil_distance: document.getElementById("prop-pd"),
    _pupil_distance_left: document.getElementById("prop-pd-left"),
    _pupil_distance_right: document.getElementById("prop-pd-right"),
    _birthdate: document.getElementById("prop-birthdate"),
  };

  function updateHiddenInputs(prescriptionValues) {
    for (const key in hiddenInputs) {
      if (hiddenInputs[key]) {
        hiddenInputs[key].value = prescriptionValues[key] || "";
      }
    }
  }

  function validateFields(container) {
    const prescriptionValues = {};
    const selectBoxes = container.querySelectorAll(".selectBox");
    let allFilled = true;

    selectBoxes.forEach((selectBox) => {
      const name = selectBox.getAttribute("id");
      const value = selectBox.getAttribute("data-value");
      prescriptionValues[name] = value;

      const template = document
        .querySelector(".product-page")
        .getAttribute("template");

      const is_mandatory_box =
        selectBox.id !== "_cylinder_left" &&
        selectBox.id !== "_cylinder_right" &&
        selectBox.id !== "_axis_left" &&
        selectBox.id !== "_axis_right" &&
        selectBox.id !== "_pupil_distance" &&
        !(
          selectBox.id === "_birthdate" &&
          !(template === "varifocal" || template === "sunglasses-varifocal")
        );

      if (!value && is_mandatory_box) {
        selectBox.classList.add("incomplete");
        allFilled = false;
      } else {
        selectBox.classList.remove("incomplete");
      }
    });

    return { prescriptionValues, allFilled };
  }

  function updateValues() {
    const { prescriptionValues, allFilled: fieldsFilled } =
      validateFields(container);

    updateHiddenInputs(prescriptionValues);

    window.single_vison.manually_added_values = prescriptionValues;
    window.single_vison.completed_manually_added_values = fieldsFilled;

    if (completeText) {
      completeText.classList.toggle("hidden", fieldsFilled);
    }
  }

  container.querySelectorAll(".selectBox").forEach((selectBox) => {
    selectBox.addEventListener("click", () => {
      setTimeout(updateValues, 0);
    });
  });

  updateValues();
});
